import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ChatMessageBubble.css';
import { IconTail } from './assets/icons';
import { EMessageType } from '../../types/messageType';
import { EUserColor } from '../../types/userName';

interface IChatMessageBubbleProps {
  messageType: EMessageType;
  withTail: boolean;
  className?: string;
  userColor?: EUserColor;
  children: React.ReactNode;
}

export const ChatMessageBubble = React.forwardRef<HTMLDivElement, IChatMessageBubbleProps>(function ChatMessageBubble(
  { children, messageType, withTail, className, userColor },
  ref,
) {
  return (
    <div
      className={clsx(
        styles['message-bubble'],
        styles[`message-bubble_type_${messageType}`],
        userColor && styles[`message-bubble_theme_${userColor}`],
      )}
      ref={ref}
      data-name="ChatMessageBubble"
    >
      <div className={clsx(styles['message-bubble__content'], className)}>{children}</div>

      {withTail && (
        <div className={styles['message-bubble__tail']}>
          <IconTail />
        </div>
      )}
    </div>
  );
});
